module.exports = __webpack_public_path__ + "img/katarina_bedrooms_17.682b9bbc.jpg";